module.exports = __webpack_public_path__ + "static/img/evidence4.b702472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence4.png
// module id = w88w
// module chunks = 1 3